module.exports = __webpack_public_path__ + "static/media/privacyPolicy.75d73616.svg";